export default __webpack_public_path__ + "static/media/medium-duration.ebb6ddb5.png";